module.exports = __webpack_public_path__ + "img/Prijslijsten.d795d181.svg";